import type { ModalFullscreenProps } from "./modal-fullscreen.type";

import { Modal, Spin } from "antd";
import classNames from "classnames";

import { useThemeBreakpoints } from "@/services/theme";

import "./modal-fullscreen.style.less";

export const ModalFullscreen = ({
  loading,
  children,
  className,
  ...modalProps
}: ModalFullscreenProps) => {
  const { isXs } = useThemeBreakpoints();

  return (
    <Modal
      {...modalProps}
      className={classNames("modal-fullscreen", className, { "-xs": isXs })}
    >
      {loading ? (
        <div
          className="modal-fullscreen-loader"
          data-testid="modal-fullscreen-loader"
        >
          <Spin />
        </div>
      ) : (
        <div className="modal-fullscreen-body">{children}</div>
      )}
    </Modal>
  );
};
